import { useContext } from "react";
import { AvisConstants } from "../../data/avisConstants";
import { useSessionStorage } from "../../hooks/useSessionStorage";
import { LoginType } from "../../models";
import { axiosApi, ErrorUtils } from "../../utils";
import { EIdActionPicker } from "../shared/components/eId/eIdActionPicker";
import { AvisContext } from "../shared/context/AvisContext";

interface IProps {
  loading: boolean;
  setError: (error?: string) => void;
  setSubmitting: (value: boolean) => void;
}

export function EIdLogin(props: Readonly<IProps>) {
  const { loading, setError, setSubmitting } = props;
  const { res, portalKind } = useContext(AvisContext);
  const [, setReturnPortalType] = useSessionStorage(
    AvisConstants.eId_return_to_portal_session_key,
  );
  const onButtonClick = (loginType: LoginType) => {
    setSubmitting(true);
    setError(undefined);

    axiosApi
      .post(
        "Auth/redirect-eid",
        {
          loginType: loginType,
          returnUrl: AvisConstants.eId_return_url_login,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
          },
        },
      )
      .then((res) => {
        //Save portal type for incoming redirect back
        setReturnPortalType(portalKind.portalType);
        location.assign(res.data.redirectUrl);
      })
      .catch((err) => {
        setSubmitting(false);
        setError(ErrorUtils.getGeneralErrorMessage(err, res));
      });
  };

  return <EIdActionPicker action={onButtonClick} loading={loading} />;
}
